import { render, staticRenderFns } from "./postCast.vue?vue&type=template&id=69133ad2&scoped=true&"
var script = {}
import style0 from "./postCast.vue?vue&type=style&index=0&id=69133ad2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69133ad2",
  null
  
)

export default component.exports